export const GET_DETAILS_DATA = 'GET_DETAILS_DATA'
export const GET_DETAILS_MULTIPLE_DATA = 'GET_DETAILS_MULTIPLE_DATA'
export const UPDATE_DETAILS_DATA = 'UPDATE_DETAILS_DATA'
export const ADD_DETAILS_DATA = 'ADD_DETAILS_DATA'
export const DELETE_DETAILS_DATA = 'DELETE_DETAILS_DATA'
export const SET_DETAILS_LOADING = 'SET_DETAILS_LOADING'

export const ADD_DISCOUNT = 'ADD_DISCOUNT'
export const UPDATE_DISCOUNT = 'UPDATE_DISCOUNT'
export const DELETE_DISCOUNT = 'DELETE_DISCOUNT'

export const ADD_VOLUME_CONTRACT = 'ADD_VOLUME_CONTRACT'
export const UPDATE_VOLUME_CONTRACT = 'UPDATE_VOLUME_CONTRACT'
export const DELETE_VOLUME_CONTRACT = 'DELETE_VOLUME_CONTRACT'

export const GET_DOCUMENTS_BEFORE_SIGNING = 'GET_DOCUMENTS_BEFORE_SIGNING'
export const GET_DOCUMENTS_AFTER_SIGNING = 'GET_DOCUMENTS_AFTER_SIGNING'

export const GET_DOCUMENT_TYPE_BEFORE_SIGNING = 'GET_DOCUMENT_TYPE_BEFORE_SIGNING'
export const GET_DOCUMENT_TYPE_AFTER_SIGNING = 'GET_DOCUMENT_TYPE_AFTER_SIGNING'

export const GET_CONTACT_DOCUMENT_NOTES = 'GET_CONTACT_DOCUMENT_NOTES'
export const CREATE_CONTACT_DOCUMENT_NOTE = 'CREATE_CONTACT_DOCUMENT_NOTE'
export const DELETE_CONTACT_DOCUMENT_NOTE = 'DELETE_CONTACT_DOCUMENT_NOTE'
